import axios from 'axios'
import {UserModel} from '../models/UserModel'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/Authenticate/verify-token`
export const LOGIN_URL = `${API_URL}/Authenticate/login`
export const LOGIN_2FA_URL = `${API_URL}/Authenticate/login-2FA`
export const LOGIN_MICROSOFT_URL = `${API_URL}/Authenticate/login-via-microsoft`
export const REFRESH_TOKEN_URL = `${API_URL}/Authenticate/refresh-token`
export const REGISTER_URL = `${API_URL}/Authenticate/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/Authenticate/forgot-password`

export const LOGIN_PAGE_SETTINGS_URL = `${API_URL}/Authenticate/login-page-settings`;

// Server should return AuthModel
export function login(email: string, password: string, captcha: string | null, rememberMe: boolean) {
  return axios.post(LOGIN_URL, {
    email,
    password,
    captcha,
    rememberMe,
  })
}

export function loginMicrosoftUser(
  email: string,
  captcha: string | null,
  rememberMe: boolean = true,
  oid?: string | null,
  upn?: string | null,
  microsoftBearerToken?: string | null
) {
  return axios.post(
    LOGIN_MICROSOFT_URL,
    {
      email,
      captcha,
      rememberMe,
      oid,
      upn,
    },
    {
      headers: microsoftBearerToken
        ? {
            Authorization: `Bearer ${microsoftBearerToken}`,
          }
        : undefined,
      skipAuthRefresh: true,
    } as any
  )
}


export function loginPageSettings() {
  return axios.get(LOGIN_PAGE_SETTINGS_URL);
}

export function login2Fa(email: string, code: string, rememberMe: boolean) {
  return axios.post(LOGIN_2FA_URL, {
    email,
    code,
    rememberMe,
  })
}

export interface RefreshTokenResponse {
  token: string
  longTermToken?: string
  refreshToken: string
  expiration: string
  name?: string
}

export function refreshToken(
  refreshTokenValue: string,
  rememberMe: boolean,
  email?: string
) {
  return axios.post<RefreshTokenResponse>(REFRESH_TOKEN_URL, {
    email,
    refreshToken: refreshTokenValue,
    rememberMe,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    apiToken: token,
  })
}
